import classNames from 'classnames';

interface ShadowsExampleProps {
    className: string;
    lightMode?: boolean;
}

export const ShadowsExample = ({ className, lightMode = false }: ShadowsExampleProps) => (
    <div
        className={classNames('sds_shadows-background', {
            'sds_shadows-background--light': lightMode,
        })}
    >
        background
        <div className={classNames('sds_shadows', { 'sds_shadows--light': lightMode }, className)}>
            foreground
        </div>
    </div>
);
